import React from 'react';
import { StarIcon } from 'lucide-react';
// Testimonials for marquee rows
const shortTestimonialsRowA = [{
  quote: "First thing in years that didn't make me feel broken. It explained what was happening, not just told me to stop.",
  author: 'Thomas K.',
  details: '34, Berlin'
}, {
  quote: 'My focus came back within a week. I had no idea how much energy I was burning fighting myself.',
  author: 'Andrew P.',
  details: '29, Dublin'
}, {
  quote: 'No streak counting, no shame spirals. Just clarity about what dopamine was actually doing in my brain.',
  author: 'Christopher L.',
  details: '37, Denver'
}, {
  quote: 'I feel emotionally present with my partner again. That alone was worth ten times the price.',
  author: 'Ryan M.',
  details: '33, Vancouver'
}, {
  quote: 'Calm, intelligent, never preachy. It reads like a neuroscience essay, not a self-help manual.',
  author: 'Jonathan F.',
  details: '40, Boston'
}, {
  quote: "The urges didn't go away through force. They lost their emotional weight. Completely different feeling.",
  author: 'Lucas D.',
  details: '26, Lisbon'
}];
const shortTestimonialsRowB = [{
  quote: 'I sleep through the night now. I forgot what that even felt like as an adult.',
  author: 'Benjamin H.',
  details: '38, Sydney'
}, {
  quote: "I read it slowly over a weekend. By Monday something had shifted that I can't fully explain.",
  author: 'Samuel R.',
  details: '31, Manchester'
}, {
  quote: 'It treated me like an adult caught in a biological trap, not a weak person who lacked discipline.',
  author: 'Nathaniel B.',
  details: '36, Amsterdam'
}, {
  quote: 'The shame just quietly disappeared. I stopped hating myself in the mornings.',
  author: 'Oliver J.',
  details: '30, Edinburgh'
}, {
  quote: "It's not a quit-porn book. It's a how-your-brain-got-hijacked book. That distinction changed everything for me.",
  author: 'Henry C.',
  details: '42, Portland'
}, {
  quote: 'My anxiety baseline dropped within two weeks. I am genuinely calmer in my own body.',
  author: 'Elliot V.',
  details: '35, Stockholm'
}];
type ShortQuote = {
  quote: string;
  author: string;
  details: string;
};
function MarqueeCard({
  item
}: {
  item: ShortQuote;
}) {
  return <div className="shrink-0 w-[280px] sm:w-[380px] mx-2 sm:mx-3 bg-charcoal border border-gold/10 rounded-lg p-5 sm:p-7 text-left" data-id="element-186">
      <div className="flex text-gold mb-4" data-id="element-187">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-188" />)}
      </div>
      <p className="text-ivory/85 text-sm sm:text-base font-light leading-relaxed mb-5 min-h-[5.5rem]" data-id="element-189">
        "{item.quote}"
      </p>
      <div className="pt-4 border-t border-gold/10" data-id="element-190">
        <div className="text-ivory font-medium text-sm tracking-wide" data-id="element-191">
          {item.author}
        </div>
        <div className="text-ivory/50 text-xs mt-0.5" data-id="element-192">{item.details}</div>
      </div>
    </div>;
}
function MarqueeRow({
  items,
  direction = 'left'
}: {
  items: ShortQuote[];
  direction?: 'left' | 'right';
}) {
  // Duplicate for seamless looping
  const loop = [...items, ...items];
  return <div className="marquee" data-id="element-193">
      <div className={`marquee__track ${direction === 'left' ? 'marquee__track--left' : 'marquee__track--right'}`} data-id="element-194">
        {loop.map((item, i) => <MarqueeCard key={i} item={item} data-id="element-195" />)}
      </div>
    </div>;
}
export function Testimonials() {
  return <section className="py-10 sm:py-14 bg-charcoal-light border-y border-gold/5 overflow-hidden" data-id="element-196">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center mb-7 sm:mb-10" data-id="element-197">
        <div className="text-gold tracking-[0.2em] uppercase text-xs sm:text-sm mb-4" data-id="element-198">
          Reader Reflections
        </div>
        <h2 className="font-serif text-3xl sm:text-5xl text-ivory leading-[1.15]" data-id="element-199">
          Quiet Changes, Real Lives
        </h2>
      </div>

      {/* Auto-scrolling marquee rows (pure CSS, mobile-safe) */}
      <div className="space-y-6" data-id="element-200">
        <MarqueeRow items={shortTestimonialsRowA} direction="left" data-id="element-201" />
        <MarqueeRow items={shortTestimonialsRowB} direction="right" data-id="element-202" />
      </div>
    </section>;
}